import { STRIPE_CONNECTED_ACCOUNT_IDS, BRAND_NAMES } from '../types';

export type BrandConfig = {
  name: string;
  domain: string;
  legalEntity: string;
  privacyEmail: string;
  infoEmail: string;
};

export const BRAND_CONFIGS: Record<string, BrandConfig> = {
  [STRIPE_CONNECTED_ACCOUNT_IDS.FORMSPRINT_HEALTH]: {
    name: BRAND_NAMES.FORMSPRINT_HEALTH,
    domain: 'formsprinthealth.com',
    legalEntity: 'SyncFlow Solutions, LLC',
    privacyEmail: 'privacy@formsprinthealth.com',
    infoEmail: 'info@formsprinthealth.com',
  },
  [STRIPE_CONNECTED_ACCOUNT_IDS.BESTI_HEALTH]: {
    name: BRAND_NAMES.BESTI_HEALTH,
    domain: 'bestihealth.com',
    legalEntity: 'SyncFlow Solutions, LLC',
    privacyEmail: 'privacy@bestihealth.com',
    infoEmail: 'info@bestihealth.com',
  },
  [STRIPE_CONNECTED_ACCOUNT_IDS.KINETIC_NOTES]: {
    name: BRAND_NAMES.KINETIC_SCRIBE,
    domain: 'kineticscribe.com',
    legalEntity: 'SyncFlow Solutions, LLC',
    privacyEmail: 'privacy@kineticscribe.com',
    infoEmail: 'info@kineticscribe.com',
  },
};

export const getBrandConfig = (): BrandConfig => {
  const stripeConnectedAccountId = import.meta.env.VITE_STRIPE_CONNECTED_ACCOUNT_ID;
  return BRAND_CONFIGS[stripeConnectedAccountId] || BRAND_CONFIGS[STRIPE_CONNECTED_ACCOUNT_IDS.FORMSPRINT_HEALTH];
};

export const getBrandConfigById = (accountId: string): BrandConfig => {
  return BRAND_CONFIGS[accountId] || BRAND_CONFIGS[STRIPE_CONNECTED_ACCOUNT_IDS.FORMSPRINT_HEALTH];
};

export const getBrandName = (): string => {
  const stripeConnectedAccountId = import.meta.env.VITE_STRIPE_CONNECTED_ACCOUNT_ID;
  switch (stripeConnectedAccountId) {
    case STRIPE_CONNECTED_ACCOUNT_IDS.FORMSPRINT_HEALTH:
      return BRAND_NAMES.FORMSPRINT_HEALTH;
    case STRIPE_CONNECTED_ACCOUNT_IDS.BESTI_HEALTH:
      return BRAND_NAMES.BESTI_HEALTH;
    case STRIPE_CONNECTED_ACCOUNT_IDS.KINETIC_NOTES:
      return BRAND_NAMES.KINETIC_SCRIBE;
    default:
      return BRAND_NAMES.FORMSPRINT_HEALTH;
  }
};

export const isBestiHealthAccount = (): boolean => {
  const stripeConnectedAccountId = import.meta.env.VITE_STRIPE_CONNECTED_ACCOUNT_ID;
  return stripeConnectedAccountId === STRIPE_CONNECTED_ACCOUNT_IDS.BESTI_HEALTH;
};

export const isKineticNotesAccount = (): boolean => {
  const stripeConnectedAccountId = import.meta.env.VITE_STRIPE_CONNECTED_ACCOUNT_ID;
  return stripeConnectedAccountId === STRIPE_CONNECTED_ACCOUNT_IDS.KINETIC_NOTES;
};

export const cleanMarkdownJson = (rawOutput: string): string => {
  let cleanedOutput = rawOutput.trim();
  
  // Remove ```json from the beginning if present
  if (cleanedOutput.startsWith('```json')) {
    cleanedOutput = cleanedOutput.substring(7).trim();
  } else if (cleanedOutput.startsWith('```')) {
    cleanedOutput = cleanedOutput.substring(3).trim();
  }
  
  // Remove ``` from the end if present
  if (cleanedOutput.endsWith('```')) {
    cleanedOutput = cleanedOutput.substring(0, cleanedOutput.length - 3).trim();
  }
  
  return cleanedOutput;
}; 